import { useEffect, useRef } from 'react';
import css from "./register.module.css";
import RegisterForm from "./registerForm";
import lessonThumbnail1 from '../../img/my_study_routine_foto.jpg';
import lessonThumbnail2 from '../../img/my_trip_to_Barcelona_foto.jpg';
import lessonThumbnail3 from '../../img/Аirport_announcement_3_foto.jpg';
import lessonThumbnail4 from '../../img/don_t_rely_on_the_gate_agents_foto.jpg';
import { trackSignupShown } from '../../lib/analytics';
import { useTranslation } from 'react-i18next';

const Main = () => {
const statsRef = useRef([]);
const { t } = useTranslation();

  const animateValue = (element, start, end, duration) => {
    const range = end - start;
    const increment = range / (duration / 16); // 16ms per frame for 60fps
    let current = start;
    
    const updateCounter = () => {
      current += increment;
      if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
        element.textContent = end;
        return;
      }
      element.textContent = Math.floor(current);
      requestAnimationFrame(updateCounter);
    };

    requestAnimationFrame(updateCounter);
  };

  useEffect(() => {
    // Set up Intersection Observer for stat values
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;
          const value = parseInt(target.textContent, 10);
          animateValue(target, 0, value, 1500); // Animate over 1.5 seconds
          observer.unobserve(target); // Only animate once
        }
      });
    }, { threshold: 0.5 });

    // Observe all stat values
    statsRef.current.forEach(stat => {
      if (stat) observer.observe(stat);
    });

    return () => observer.disconnect();
  }, []);


  useEffect(() => {
    // Track signup page shown
    trackSignupShown();
  }, []);

  useEffect(() => {
    // Add ripple animation styles
    const style = document.createElement('style');
    style.textContent = `
      @keyframes ripple-effect {
        from {
          transform: scale(0);
          opacity: 1;
        }
        to {
          transform: scale(4);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className={css.main}>
      <div className={css.mainBg}></div>

      <div className={css.container}>
        <div className={css.regwallCard}>
          <RegisterForm />
      
          <div className={css.dashboardPreview}>
            {/* Value Banner */}
            <div className={css.valueBanner}>
              <div className={css.bannerContent}>
                <div className={css.bannerIcon}>
                 <svg viewBox="0 0 24 24">
                                <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"></path>
                            </svg>
                </div>
                <div className={css.bannerText}>
                  <strong>{t("After registration, you'll get your personalized course and be able to track your progress.")}</strong>
                  {t("Start your language learning journey with AI-powered lessons tailored just for you!")}
                </div>
              </div>
            </div>

            {/* Welcome Section */}
            <div className={css.welcomeSection}>
              <h2 className={css.welcomeTitle}>{t("Welcome Back, aliona!")}</h2>
              <p className={css.welcomeSubtitle}>{t("Let's continue studying together")}</p>
            </div>

            {/* Stats Grid */}
            <div className={css.statsGrid}>
              <div className={css.statCard}>
                <div className={css.statValue} ref={el => statsRef.current[0] = el}>109</div>
                <div className={css.statLabel}>{t("Learned Words")}</div>
              </div>
              <div className={css.statCard}>
                <div className={css.statValue} ref={el => statsRef.current[1] = el}>1</div>
                <div className={css.statLabel}>{t("Completed Videos")}</div>
              </div>
              <div className={css.statCard}>
                <div className={css.statValue} ref={el => statsRef.current[2] = el}>18</div>
                <div className={css.statLabel}>{t("Correct Answers")}</div>
              </div>
              <div className={css.statCard}>
                <div className={css.statValue} ref={el => statsRef.current[3] = el}>0</div>
                <div className={css.statLabel}>{t("Completed Dialogs")}</div>
              </div>
            </div>

            {/* Courses Section */}
            <div className={css.coursesContainer}>
              <div className={css.sectionHeader}>
                <h3 className={css.sectionTitle}><span style={{fontSize: "24px"}}>📚</span>{t("My Courses")}</h3>
                <a href="#" className={css.viewAllLink}>{t("View all courses")} →</a>
              </div>
              <div className={css.coursesList}>
                <div className={css.courseItem}>
                  <div className={css.courseHeader}>
                    <div className={css.courseBadge}>GB</div>
                    <div className={css.courseInfo}>
                      <h4>{t("Business English")}</h4>
                      <div className={css.courseMeta}>{t("Intermediate")} • {t("24 lessons")}</div>
                    </div>
                  </div>
                  <div className={css.progressSection}>
                    <div className={css.progressHeader}>
                      <span>{t("Progress")}</span>
                      <span>72%</span>
                    </div>
                    <div className={css.progressBar}>
                      <div className={css.progressFill} style={{width: '72%'}}></div>
                    </div>
                  </div>

                  <div className={css.courseDetails}>
                                <span><strong>18</strong> {t("lessons done")}</span>
                                <span><strong>245</strong> {t("words")}</span>
                                <span><strong>6</strong> {t("lessons left")}</span>
                            </div>
                </div>
                <div className={css.courseItem}>
                  <div className={css.courseHeader}>
                    <div className={css.courseBadge}>💬</div>
                    <div className={css.courseInfo}>
                      <h4>{t("Conversational English")}</h4>
                      <div className={css.courseMeta}>{t("Beginner")} • {t("30 lessons")}</div>
                    </div>
                  </div>
                  <div className={css.progressSection}>
                    <div className={css.progressHeader}>
                      <span>{t("Progress")}</span>
                      <span>35%</span>
                    </div>
                    <div className={css.progressBar}>
                      <div className={css.progressFill} style={{width: '35%'}}></div>
                    </div>
                  </div>
                  <div className={css.courseDetails}>
                                <span><strong>13</strong> {t("lessons done")}</span>
                                <span><strong>156</strong> {t("words")}</span>
                                <span><strong>17</strong> {t("lessons left")}</span>
                            </div>
                </div>
                <div className={css.courseItem}>
                  <div className={css.courseHeader}>
                    <div className={css.courseBadge}>✈️</div>
                    <div className={css.courseInfo}>
                      <h4>{t("Travel English")}</h4>
                      <div className={css.courseMeta}>{t("Intermediate")} • {t("15 lessons")}</div>
                    </div>
                  </div>
                  <div className={css.progressSection}>
                    <div className={css.progressHeader}>
                      <span>{t("Progress")}</span>
                      <span>20%</span>
                    </div>
                    <div className={css.progressBar}>
                      <div className={css.progressFill} style={{width: '20%'}}></div>
                    </div>
                  </div>
                  <div className={css.courseDetails}>
                                <span><strong>3</strong> {t("lessons done")}</span>
                                <span><strong>42</strong> {t("words")}</span>
                                <span><strong>12</strong> {t("lessons left")}</span>
                            </div>
                </div>
              </div>
            </div>

            {/* Videos Section */}
            <div className={css.videosSection}>
              <div className={css.sectionHeader}>
                <h3 className={css.sectionTitle}><span style={{fontSize: "24px"}}>🎬</span>{t("My Videos")}</h3>
                <a href="#" className={css.viewAllLink}>{t("View all")} →</a>
              </div>
              <div className={css.videosGrid}>
                <div className={css.videoCard}>
                  <div className={css.videoThumbnail}><img src={lessonThumbnail1} alt="" /></div>
                </div>
                <div className={css.videoCard}>
                  <div className={css.videoThumbnail}><img src={lessonThumbnail2} alt="" /></div>
                </div>
                <div className={css.videoCard}>
                  <div className={css.videoThumbnail}><img src={lessonThumbnail3} alt="" /></div>
                </div>
                <div className={css.videoCard}>
                  <div className={css.videoThumbnail}><img src={lessonThumbnail4} alt="" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
